import React, { useState } from 'react';

export default function CopyValue({ label, value, buttonLabel = null, className = '' }) {
  const [status, setStatus] = useState('');
  const copyLabel = buttonLabel || `Copy ${label}`;

  const copyValue = async () => {
    setStatus('');
    try {
      await navigator.clipboard.writeText(value);
      setStatus('Copied');
    } catch (error) {
      setStatus('Copy failed');
    }
  };

  return (
    <div className={['copy-value', className].filter(Boolean).join(' ')}>
      <span className="copy-value-label">{label}</span>
      <code className="copy-value-code">{value}</code>
      <button className="secondary-button copy-value-button" type="button" onClick={copyValue} aria-label={copyLabel}>
        Copy
      </button>
      {status ? (
        <span className={status === 'Copied' ? 'copy-value-status' : 'copy-value-status copy-value-status-alert'} role="status">
          {status}
        </span>
      ) : null}
    </div>
  );
}
